import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { RouteState } from 'src/app/_models/state/routeState';
import { DirectionsReportReportLineView } from '../../_models/view/directionsReportView';

@Component({
  selector: 'app-driving-directions-report',
  templateUrl: './driving-directions-report.component.html',
  styleUrls: ['./driving-directions-report.component.scss'],
})
export class DrivingDirectionsReportComponent implements OnInit {
  @Input() route: RouteState;
  @Input() printView: boolean;
  @Input() distanceUnits: number;
  @Input() precision: number;
  directionReportLines: DirectionsReportReportLineView[] = [];
  disclaimer: string | '' = '';
  stopCount = 1;
  ngOnInit(): void {
    const drivingDirectionsReportCopy = cloneDeep(
      this.route?.drivingDirectionsReport
    );
    this.directionReportLines = drivingDirectionsReportCopy?.ReportLegs.map(
      (directionReportLeg) => directionReportLeg?.ReportLines
    )
      .map((reportLines) =>
        reportLines?.filter((rl) => {
          if (rl.Begin === null) {
            this.disclaimer += rl.Direction;
          }
          return rl.Begin !== null;
        })
      )
      .reduce(
        (acc, res) => acc.concat(res ? res : []),
        [] as DirectionsReportReportLineView[]
      );

    if (this.directionReportLines.length) {
      this.addStops(this.directionReportLines);
    }
  }

  addStops(drivingDirectionReportLines: DirectionsReportReportLineView[]) {
    let i = 0;
    drivingDirectionReportLines.forEach((reportLines, index) => {
      if (
        reportLines?.Begin?.Lat === reportLines?.End?.Lat &&
        reportLines?.Begin?.Lon === reportLines?.End?.Lon
      ) {
        reportLines.routeAddress = this.route.stopsState[i];
        i++;

        if (index === 0) {
          reportLines.Stop = `Origin: ${reportLines.Direction}`;
        } else if (index === drivingDirectionReportLines.length - 1) {
          reportLines.Stop = `Dest: ${reportLines.Direction}`;
        } else if (
          index !== 0 &&
          index !== drivingDirectionReportLines.length - 1
        ) {
          reportLines.Stop = `Stop ${this.stopCount}: ${reportLines.Direction}`;
          this.stopCount++;
        }
      }
    });
  }
}
